import React, { useEffect } from 'react';
import { Route, useLocation, useNavigate } from 'react-router-dom';
import ReviewCardDetails from '../../components/Review/Card/ReviewCardDetails';
import ReviewProvider from '../Reviews/ReviewProvider';
import Feed from '../Reviews/Tabs/Feed';
import Invite from '../Reviews/Tabs/Invite';
import TwitterTakes from '../Reviews/Tabs/TwitterTakes';
import Write from '../Reviews/Tabs/Write';
import TwitterReviewDetailCard from '../../components/Review/Card/TwitterReviewDetailCard';

function FeedRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/takes/feed');
  }, [navigate]);
  return <></>;
}

const TakeRoutes = () => {
  return (
    <Route path='/takes' element={<ReviewProvider />}>
      <Route path='/takes' element={<FeedRedirect />} />
      <Route path='/takes/feed' element={<Feed />} />
      <Route path='/takes/feed/:uuid' element={<ReviewCardDetails />} />
      <Route path='/takes/twittertakes/:uuid' element={<TwitterReviewDetailCard />} />
      <Route path='/takes/twittertakes' element={<TwitterTakes />} />
      <Route path='/takes/write' element={<Write />} />
      <Route path='/takes/invite' element={<Invite />} />
    </Route>
  );
};

export default TakeRoutes;
